import { render, staticRenderFns } from "./SocialProof.vue?vue&type=template&id=e99fa5fc&scoped=true&"
import script from "./SocialProof.vue?vue&type=script&lang=js&"
export * from "./SocialProof.vue?vue&type=script&lang=js&"
import style0 from "./SocialProof.vue?vue&type=style&index=0&id=e99fa5fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99fa5fc",
  null
  
)

export default component.exports